import lazyInit from 'util/lazyInit';

const getCounter = lazyInit<{value: number}>(() => ({value: 0}));

/**
 * Vendored `_.uniqueId` as implemented by underscore@1.13.7, ported to TypeScript, see
 * https://github.com/jashkenas/underscore/blob/1.13.7/modules/uniqueId.js
 *
 * Returns a string id that is unique within the lifetime of the counter, optionally prefixed.
 *
 * The counter is held in a `lazyInit` global so it restarts at 1 whenever lazy globals are reset,
 * which makes generated ids deterministic per test rather than dependent on how many ids earlier
 * tests happened to consume. Ids are therefore only unique between resets: never persist one
 * across a reset and compare it against a later id. Useful for resetting between test executions
 * for determinism; never use in production code.
 */
export default function uniqueId(prefix?: string): string {
  const counter = getCounter();
  counter.value += 1;
  const id = String(counter.value);
  return prefix == null ? id : `${prefix}${id}`;
}
